import React from 'react';
import { Wrapper } from '../../atoms/wrapper';
import { Section } from '../../enums/container';
import * as styles from './steps_section.module.sass';
import { Color } from '../../enums/color';
import { StepsContainer } from '../../organism/StepsContainer';



export const StartSection = (props: any) => {
  
  return (
    <Wrapper section={Section.START} background_color={Color.PRIMARY} cardClassName={styles.start_sect}>
      <h2 className={styles.start_sect_header}>{props.title}</h2>
      <StepsContainer
        steps={props.steps}
        srcs={props.srcs}
        src={props.src}
        alt={props.alt}
        stepsClassName={props.stepsClassName}
        stepsCircleClassName={props.stepsCircleClassName}
      />
    </Wrapper>
  );
};
